import script from "./cookiesPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./cookiesPolicy.vue?vue&type=script&setup=true&lang=js"

import "./cookiesPolicy.vue?vue&type=style&index=0&id=4f7155e1&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7155e1"]])

export default __exports__